export const ROOM_TOUR_STORAGE_KEY = "constela_room_tour_v1";

export function hasSeenRoomTour(): boolean {
    try {
        return localStorage.getItem(ROOM_TOUR_STORAGE_KEY) === "1";
    } catch {
        return false;
    }
}

export function markRoomTourSeen(): void {
    try {
        localStorage.setItem(ROOM_TOUR_STORAGE_KEY, "1");
    } catch {
        // ignore quota / private mode
    }
}

export function clearRoomTourSeen(): void {
    try {
        localStorage.removeItem(ROOM_TOUR_STORAGE_KEY);
    } catch {
        // ignore
    }
}
